<!-- Navbar -->
<nav class="navbar navbar-expand navbar-white navbar-light main-header">
  <div class="d-flex">
    <button
      class="border-0 bg-transparent p-2 hamburger-menu"
      (click)="navigationService.isExpanded = !navigationService.isExpanded"
      [title]="!navigationService.isExpanded ? 'Expand' : 'Collapse'"
    >
      <img
        src="./assets/icons/hamburger-menu.svg"
        alt="Menu"
        width="30px"
        height="30px"
      />
    </button>
  </div>
  <div class="logo">
    <img
      src="./assets/images/Logo.svg"
      class="logo"
      priority
      fill
      width="76px"
      height="25px"
    />
  </div>
  <div class="date-time">
    {{ this.dataService.currentTimeString }}
  </div>
  <div class="greet-wrapper">
    <div class="greet-message">
      Hi {{ user.employee?.firstName?.charAt(0)?.toUpperCase() }},
      {{ user.employee?.lastName?.toUpperCase() }}
    </div>
    <span
      class="initials"
      #icon
      (mouseenter)="insideIcon = true; showActions = true"
      (mouseleave)="insideIcon = false; leaveIcon(0.5)"
    >
      {{ user.employee?.firstName?.charAt(0)?.toUpperCase()
      }}{{ user.employee?.lastName?.charAt(0)?.toUpperCase() }}</span
    >
  </div>

  <div
    class="action-menu"
    *ngIf="showActions"
    #insideElement
    (mouseenter)="insideActionMenu = true"
    (mouseleave)="insideActionMenu = false; showActions = false"
  >
    <ng-container *ngIf="showRole">
      <p
        class="f-14 mb-0 py-1 px-2"
      >
        {{
          user.employee?.firstName +
            " " +
            user.employee?.lastName +
            " (" +
            user.roleClass?.roleName +
            ")"
        }}
      </p>
      <p class="f-12 mb-0 py-1 px-2">{{ user.employee?.designation?.name }}</p>
      <p
  class="f-14 mb-0 py-1 px-2 highlighthover pointer"
  (click)="navigateProfile()"
>
  My Info
</p>
    </ng-container>
    <p
      class="f-14 mb-0 py-1 px-2 highlighthover pointer"
      *ngIf="getPermissionSettings('settingAccess')"
      (click)="navigateSettings()"
    >
      Settings
    </p>
    <p
      class="f-14 mb-0 py-1 px-2 highlighthover pointer"
      *ngIf="getPermissionSettings('userAccess')"
      (click)="navigateUsers()"
    >
      User Management
    </p>
    <!-- <p
      class="f-14 mb-0 py-1 px-2 highlighthover pointer"
      (click)="navigatePermissions()"
    >
      Permissions
    </p> -->
    @if (roleCode != "RA006") {
      <p class="f-14 mb-0 py-1 px-2 highlighthover" (click)="resetPassword()">
        Change Password
      </p>
    }
    <p class="f-14 mb-0 py-1 px-2 highlighthover" (click)="signOut()">Logout</p>
  </div>
</nav>

<!-- /.navbar -->
